import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Providers } from "./app/providers.tsx";
import { AppRouter } from "./app/router.tsx";
import { loadControlPlaneRuntimeConfig } from "./app/runtime-config.ts";
import "./styles/globals.css";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Control Plane root element is missing.");
}

const root = createRoot(rootElement);

function renderBootstrapError(message: string) {
  root.render(
    <StrictMode>
      <div className="min-h-screen bg-[var(--bg)] text-[var(--text)]">
        <div className="mx-auto flex min-h-screen max-w-2xl items-center px-6 py-16">
          <div className="w-full rounded-[var(--radius-lg)] border border-[var(--border)] bg-[var(--card)] p-8 shadow-[var(--shadow-md)]">
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[var(--accent)]">
              Bootstrap Error
            </p>
            <h1 className="mt-3 text-2xl font-semibold text-[var(--text-strong)]">
              Control Plane configuration failed to load
            </h1>
            <p className="mt-3 text-sm text-[var(--muted-foreground)]">
              The server-side runtime configuration for this app is missing or invalid.
            </p>
            <pre className="mt-6 overflow-x-auto rounded-[var(--radius-md)] border border-[var(--border)] bg-[var(--bg-accent)] p-4 text-xs text-[var(--muted-foreground)]">
              {message}
            </pre>
          </div>
        </div>
      </div>
    </StrictMode>,
  );
}

async function bootstrap() {
  try {
    await loadControlPlaneRuntimeConfig();
    root.render(
      <StrictMode>
        <Providers>
          <AppRouter />
        </Providers>
      </StrictMode>,
    );
  } catch (error) {
    renderBootstrapError(error instanceof Error ? error.message : "Unknown bootstrap error.");
  }
}

void bootstrap();
